import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon, SparklesIcon, ArrowUpRightIcon } from 'lucide-react';
interface QuickLink {
  label: string;
  href: string;
}
const QUICK_LINKS: QuickLink[] = [{
  label: 'Qué incluye',
  href: '#incluye'
}, {
  label: 'Los 6 tomos',
  href: '#tomos'
}, {
  label: 'Bonos',
  href: '#bonos'
}, {
  label: 'Preguntas frecuentes',
  href: '#faq'
}, {
  label: 'Acceder al Mega Pack',
  href: '#comprar'
}];
const LEGAL_LINKS: QuickLink[] = [{
  label: 'Términos y condiciones',
  href: '#faq'
}, {
  label: 'Política de privacidad',
  href: '#faq'
}, {
  label: 'Política de reembolso',
  href: '#faq'
}];
export function Footer() {
  return <footer id="site-footer" className="relative overflow-hidden bg-blush pb-16 lg:pb-0" data-id="element-78" data-mp="3lgop4lv2k8qa">
      <div className="h-px w-full bg-gradient-to-r from-transparent via-rose/30 to-transparent" aria-hidden data-id="element-79" data-mp="3qfjiuiukrhp6" />
      <div className="pointer-events-none absolute -bottom-28 -right-20 h-72 w-72 rounded-full bg-rose-soft/20 blur-3xl" aria-hidden data-id="element-80" data-mp="2a1jjpa3jzw2z" />

      <div className="relative mx-auto max-w-6xl px-5 py-10 sm:py-12" data-id="element-81" data-mp="3labp9pa6nun7">
        <div className="grid gap-10 md:grid-cols-3 md:gap-8 lg:gap-12" data-id="element-82" data-mp="3gaz1n2bhmjjk">
          {/* Marca y producto */}
          <div className="md:col-span-1" data-id="element-83" data-mp="3v7zwheoz6um9">
            <p className="font-display text-2xl leading-tight text-ink" data-id="element-84" data-mp="3v916rgy63d2x">
              Estética Digital{' '}
              <span className="bg-gradient-to-r from-[#3e4ee9] via-[#9750d8] to-[#ff7396] bg-clip-text text-transparent" data-id="element-85" data-mp="3qazr75zy9vw7">
                PRO
              </span>
            </p>
            <p className="mt-2 inline-flex items-center gap-1.5 rounded-full border border-rose/20 bg-white px-3 py-1 text-[0.7rem] font-semibold uppercase tracking-[0.14em] text-rose-deep" data-id="element-86" data-mp="33e3x3jw4ep1">
              <SparklesIcon className="h-3 w-3 text-rose" aria-hidden data-id="element-87" data-mp="cu8ugk4660ga" />
              Mega Pack 6 en 1
            </p>
            <p className="mt-3 text-sm font-medium text-ink/70" data-id="element-88" data-mp="qrf9c3lrvf08">
              Mega Pack 6 en 1 para convertir seguidores en pacientes
            </p>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-ink/60" data-id="element-89" data-mp="tvw6kdlnj9ee">
              Recursos prácticos para ayudar a profesionales de la estética a mejorar su presencia
              digital, crear contenido estratégico y convertir consultas en nuevos turnos.
            </p>
          </div>

          {/* Enlaces rápidos */}
          <nav aria-label="Enlaces rápidos" data-id="element-90" data-mp="18lkbdot1kq6v">
            <h2 className="text-xs font-bold uppercase tracking-[0.18em] text-rose-deep" data-id="element-91" data-mp="1clunlj7fgcu6">
              Explorá el pack
            </h2>
            <ul className="mt-4 space-y-2.5" data-id="element-92" data-mp="1hje28k81ermn">
              {QUICK_LINKS.map(link => <li key={link.label} data-id="element-93" data-mp="1mktp8htrz87o">
                  <a href={link.href} className="group inline-flex items-center gap-1.5 text-sm text-ink/70 transition-colors hover:text-rose-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-rose/40" data-id="element-94" data-mp="1mhpa4perus28">
                    {link.label}
                    <ArrowUpRightIcon className="h-3.5 w-3.5 text-rose/50 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-rose" aria-hidden data-id="element-95" data-mp="2afnab5srhpx4" />
                  </a>
                </li>)}
            </ul>
          </nav>

          {/* Soporte */}
          <div data-id="element-96" data-mp="1wlvzlu3anzzt">
            <h2 className="text-xs font-bold uppercase tracking-[0.18em] text-rose-deep" data-id="element-97" data-mp="2tdzo54umbnz1">Soporte</h2>
            <ul className="mt-4 space-y-2.5 text-sm" data-id="element-98" data-mp="2pcnrwgh8o4hv">
              <li data-id="element-99" data-mp="2pcw4s8dd39t2">
                <a href="mailto:soporte@creativodigital.shop" className="inline-flex items-center gap-2.5 text-ink/70 transition-colors hover:text-rose-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-rose/40" data-id="element-100" data-mp="2pa9wu7mk6sab">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white shadow-sm" data-id="element-101" data-mp="18vrxjr5r88ax">
                    <MailIcon className="h-4 w-4 text-rose" aria-hidden data-id="element-102" data-mp="2rvzk96vevtqj" />
                  </span>
                  soporte@creativodigital.shop
                </a>
              </li>
              <li data-id="element-103" data-mp="2woao2kt9vzod">
                <a href="https://instagram.com/creativodigitalstudio" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 text-ink/70 transition-colors hover:text-rose-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-rose/40" data-id="element-104" data-mp="2ivb3w5ijphah">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white shadow-sm" data-id="element-105" data-mp="31lj5ukaie1p3">
                    <InstagramIcon className="h-4 w-4 text-rose" aria-hidden data-id="element-106" data-mp="36k462jprgldj" />
                  </span>
                  @creativodigitalstudio
                </a>
              </li>
              <li data-id="element-107" data-mp="1v5gww4kwqmy5">
                <a href="https://creativodigital.shop" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 text-ink/70 transition-colors hover:text-rose-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-rose/40" data-id="element-108" data-mp="1v6034o173mwc">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white shadow-sm" data-id="element-109" data-mp="1wk9ur8mqad4t">
                    <GlobeIcon className="h-4 w-4 text-rose" aria-hidden data-id="element-110" data-mp="13xp1g2mozqym" />
                  </span>
                  creativodigital.shop
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Legales */}
        <ul className="mt-10 flex flex-wrap gap-x-5 gap-y-2 text-xs text-ink/45" data-id="element-111" data-mp="1dojnb5w10ojj">
          {LEGAL_LINKS.map(link => <li key={link.label} data-id="element-112" data-mp="18uyq3g29byle">
              <a href={link.href} className="transition-colors hover:text-rose-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-rose/40" data-id="element-113" data-mp="l6yzcg4y486t">
                {link.label}
              </a>
            </li>)}
        </ul>

        {/* Cierre */}
        <div className="mt-6 border-t border-rose/10 pt-6" data-id="element-114" data-mp="2l8f9znv94nhn">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between" data-id="element-115" data-mp="2q0ou2n9oqtc0">
            <p className="text-xs text-ink/50" data-id="element-116" data-mp="2uz9y6xs25x5q">
              © 2026 Estética Digital PRO · Creativo Digital. Todos los derechos reservados.
            </p>
            <p className="text-xs text-ink/45" data-id="element-117" data-mp="1xdm088fyf6s3">
              Un producto de{' '}
              <a href="https://creativodigital.shop" target="_blank" rel="noreferrer" className="font-semibold text-rose-deep transition-colors hover:text-rose focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-rose/40" data-id="element-118" data-mp="22bnn74gi3q8u">
                Creativo Digital
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>;
}